var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},_vm._l((_vm.imgs),function(item){return _c('div',{key:item.num,staticClass:"eve",style:(item.style),on:{"click":function($event){return _vm.go(item.num)}}},[_c('img',{attrs:{"src":item.url,"alt":""}}),_c('span',[_vm._v(_vm._s(item.tit))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }